import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {tap, map, catchError} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';

@Injectable()
export abstract class CrudDataGenericService<T> {
  private currentData: T;
  private originalData: T;
  protected dataToSave: T;
  protected abstract url;

  get _url() {
    console.log('get');
    return '/api' + this.url;
  }

  get manageUrl() {
    return this._url.slice(0, -1) + '_manage/';
  }

  constructor(protected http: HttpClient) {
  }

  get data(): T {
    return this.currentData;
  }

  set data(data: T) {
    this.originalData = data;
    this.currentData = JSON.parse(JSON.stringify(data));
  }

  protected helperCopyData(from, to) {
    for (const field of Object.keys(from)) {
      to[field] = from[field]; // tODO i think is from = to
    }
  }

  protected _save(arrayOrOldElement?) {
    return this.http.post(this.manageUrl, this.dataToSave).pipe(
      tap((result: T) => {
        this.postSave(result, 'save', arrayOrOldElement);
      })
    );
  }

  private _update(arrayOrOldElement?) {
    return this.http.put(`${this.manageUrl}/${this.dataToSave['id']}`, this.dataToSave).pipe(
      tap((result: T) => {
        this.postSave(result, 'update',  arrayOrOldElement);
      })
    );
  }

  protected prepareData() {
    this.dataToSave = this.currentData;
  } // has to prepare data to save

  protected postSave(data: T, action, arrayOrOldElement?) {
    this.helperCopyData(this.originalData, this.currentData);
    this.data = this.originalData;
    if (action === 'save' && arrayOrOldElement) {
      arrayOrOldElement.push(this.data);
    }
  }
  // has to update original user

  public save(arrayOrOldElement?) {
    console.log('voy a salvar');
    this.prepareData();
    if (this.data['id']) {
      return this._update(arrayOrOldElement);
    } else {
      return this._save(arrayOrOldElement);
    }

  }

  public restore() {
    this.data = this.originalData;
  }

  public delete(data, dataArray?) {
    return this.http.delete(`${this.manageUrl}/${data['id']}`).pipe(
      tap((deleteData) => {
        if (dataArray) {
          const found = dataArray.findIndex(function (element) {
            return element['id'] === data['id'];
          });
          dataArray.splice(found, 1);
        }
      })
    );
  }

  public get(id?) {
    const url = id ? this._url + id + '/' : this._url;
    console.log(url);
    return this.http.get(url);
  }

  public getAll(auth){
    console.log(auth);
    let headers = new HttpHeaders();
    headers.append("Authorization","Basic " + auth.getCsrfToken());
    console.log(headers);
    return this.http.get(this._url, {headers: headers});
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/crud-data-generic.service.ts